<template>
	<AlertCardWrapper @action-button-click="actionButtonClick" :actionTitle="actionTitle" :titleArr="titleArr" :alert="alert" />
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
export default {
	name: 'DefaultAlertAction',
	mixins: [AlertTypeBaseMixin],
	computed: {
		actionTitle() {
			return 'Got it';
		},
		title() {
			return 'Default alert action';
		},
		titleArr() {
			return [{ text: 'Default alert action' }];
		},
	},
	methods: {
		actionButtonClick() {
			this.markAlertAsCompleted();
		},
	},
};
</script>

<style scoped lang="scss"></style>
